export default __webpack_public_path__ + "static/media/bgCampaignLogin.9adb9b8d.png";